/**
 * HomeENDemoCrmContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENDemoCrmContent
 */

import { useHomeENDemoCrmContentLogic } from '@/hooks/traits/useHomeENDemoCrmContentLogic';
import type { HomeENDemoCrmContentConfig } from '@/hooks/traits/useHomeENDemoCrmContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENDemoCrmDeal } from '@app/shared';
import { HomeENDemoCrmBoardView } from '@/components/traits/HomeENDemoCrmBoardView';
import { Card } from '@almadar/ui/components';
import { HomeENDemoCrmStageChartView } from '@/components/traits/HomeENDemoCrmStageChartView';
import { HomeENDemoCrmStatsView } from '@/components/traits/HomeENDemoCrmStatsView';
import { Typography } from '@almadar/ui/components';
import { Split } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeENDemoCrmContentViewProps {
  config?: Partial<HomeENDemoCrmContentConfig>;
}

export function HomeENDemoCrmContentView({ config: propsConfig }: HomeENDemoCrmContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENDemoCrmContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENDemoCrmDeal'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENDemoCrmContent">
      {slotWriter['main'] === 'INIT' ? (<Stack className="p-5" gap="md" direction="vertical"><Stack direction="vertical" gap="none"><Typography content={renderPatternValue(__t("std-almadar-demo-crm-page:page.title"))} variant="h3" /><Typography variant="small" color="muted" content={renderPatternValue(__t("std-almadar-demo-crm-page:page.subtitle"))} /></Stack><Split gap="md" ratio="4:1"><HomeENDemoCrmBoardView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Stack direction="vertical" gap="md"><HomeENDemoCrmStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Card padding="sm"><HomeENDemoCrmStageChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card></Stack></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeENDemoCrmContentView;
